import React from 'react';
import { hasTranslation, I18n } from '@fiverr-private/i18n-react';
import { Link, Text } from '@fiverr-private/typography';
import pathfinder from '@fiverr-private/pathfinder';
import { Types } from '@fiverr-private/theme';
import { bodySizes } from '@fiverr-private/theme/src/shared/themeVars';
import { LEARN_MORE, LEARN_MORE_BACKGROUND, LEARN_MORE_CLASSIFICATION, SPECIAL_TERMS } from '../../constants';

interface TextWithLinkProps {
    body: string;
    size?: keyof typeof bodySizes;
    color?: Types.BodyColors;
    link?: string;
}

const TextWithLink: React.FC<TextWithLinkProps> = ({ body, size = 'b_md', color = 'bodyPrimary', link = '' }) => {
    if (!hasTranslation(body)) return null;

    let path;
    switch (link) {
        case LEARN_MORE_BACKGROUND:
            path = 'https://help-pro.fiverr.com/hc/en-us/articles/29905438312337-Background-checks-on-Fiverr-Pro';
            break;
        case LEARN_MORE_CLASSIFICATION:
            path =
                'https://help-pro.fiverr.com/hc/en-us/articles/29905357856145-Workforce-classification-on-Fiverr-Pro';
            break;
        case LEARN_MORE: // keep old for backward compatibility
            path =
                'https://help-pro.fiverr.com/hc/en-us/articles/29905357856145-Workforce-classification-on-Fiverr-Pro';
            break;
        case SPECIAL_TERMS:
            path = 'https://pro.fiverr.com/legal-portal/legal-terms/specialconditions';
            break;
        default:
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            path = pathfinder(link);
    }
    return (
        <Text size={size} color={color}>
            <I18n
                k={body}
                templates={{
                    link: (text) => (
                        <Link href={path} color={'inherit'} target="_blank" rel="noopener noreferrer">
                            {text}
                        </Link>
                    ),
                }}
            />
        </Text>
    );
};

export default TextWithLink;
